"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { DateInput as AriaDateInput, DateInputProps as AriaDateInputProps, DateSegment as AriaDateSegment, DateSegmentProps } from "react-aria-components";
function DateSegment(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("p-0 m-0 bg-transparent text-sm rounded-none border-none outline-none ring-0 shadow-none", "focus:bg-transparent focus:border-none focus:outline-none focus:ring-0 focus:shadow-none", "data-[focus]:bg-transparent data-[focus]:border-none data-[focus]:outline-none data-[focus]:ring-0 data-[focus]:shadow-none", "data-[focus-visible]:bg-transparent data-[focus-visible]:border-none data-[focus-visible]:outline-none data-[focus-visible]:ring-0 data-[focus-visible]:shadow-none", "data-[placeholder]:text-muted-foreground", "data-[disabled]:opacity-50 data-[disabled]:cursor-not-allowed", "data-[invalid]:text-destructive", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <AriaDateSegment className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function DateInput(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("flex gap-1 items-center w-full", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = children ?? _temp;
  let t3;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t3 = <AriaDateInput className={t1} {...props}>{t2}</AriaDateInput>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(segment) {
  return <DateSegment segment={segment} />;
}
export { DateInput, DateSegment };